export enum EnergyLabelCategoryStatus {
    Ok = "Ok",
    Warning = "Warning",
    Error = "Error"
}